import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
function CommentItem({ comment }) {
    const isAdminComment = comment.is_admin_comment;
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-items-center", children: [_jsx("div", { className: isAdminComment
                            ? "wpqt-font-semibold wpqt-text-lg"
                            : "wpqt-font-normal", children: comment.author_name }), _jsx("div", { className: "wpqt-text-sm", children: isAdminComment
                            ? __("Admin", "quicktasker")
                            : __("QuickTasker", "quicktasker") })] }), _jsx("div", { className: "wpqt-break-all wpqt-text-center wpqt-leading-normal wpqt-mb-4 md:wpqt-mb-0", children: comment.text })] }));
}
export { CommentItem };
